import * as React from 'react';
import { parse } from 'date-fns';
import { getLocale } from '../../../../../utils';
import { getCurrency } from '../../../../../cache';
import { setEveryTravelCartIdAction } from '../../../../store/everyTravel/actions';
import { getTravellersValues } from '../utils';
import { OrderStatus } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { useDispatch } from 'react-redux';
import EveryTravelInput from '../EveryTravelInput/EveryTravelInput';
const EveryTravelWidget = React.lazy(() => import('@websky/every-travel/src/Widget/Widget'));
const EveryTravelWrapper = ({ everyTravel, segment, order, setEveryTravelCart, everyTravelStyles, everyTravelSearchFormStyles, needToConfirmCart }) => {
    const locale = getLocale(), currency = getCurrency();
    const theme = useTheme('Checkout').ServicesAggregationPage;
    const dispatch = useDispatch();
    const updateCart = React.useCallback((cart) => {
        setEveryTravelCart(cart);
        dispatch(setEveryTravelCartIdAction({
            cartId: cart === null || cart === void 0 ? void 0 : cart.cartId
        }));
    }, [setEveryTravelCart, dispatch]);
    const everyTravelParams = React.useMemo(() => {
        var _a, _b, _c, _d;
        return ({
            cartId: everyTravel.initializeParameters.cartId,
            orderId: everyTravel.initializeParameters.orderId,
            userId: everyTravel.initializeParameters.userId,
            arrDate: everyTravel.initializeParameters.arrDate
                ? parse(everyTravel.initializeParameters.arrDate, 'yyyy-MM-dd', new Date())
                : null,
            depDate: everyTravel.initializeParameters.depDate
                ? parse(everyTravel.initializeParameters.depDate, 'yyyy-MM-dd', new Date())
                : null,
            apiEndpoint: everyTravel.endpoint,
            authToken: everyTravel.authToken,
            currency,
            widgetLocale: locale,
            containerClassName: theme.container,
            city: {
                name: (_a = segment.arrival.airport.city) === null || _a === void 0 ? void 0 : _a.name,
                countryIso: everyTravel.initializeParameters.countryIso2,
                countryId: everyTravel.initializeParameters.countryGeonamesId,
                imageUrl: (_d = (_c = (_b = segment.arrival.airport.city) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.panorama) === null || _d === void 0 ? void 0 : _d.url,
                latitude: parseFloat(segment.arrival.airport.latitude),
                longitude: parseFloat(segment.arrival.airport.longitude)
            },
            travellers: getTravellersValues(everyTravel.initializeParameters.travellers, order.customer.values),
            initCart: setEveryTravelCart,
            updateCart,
            renderInput: EveryTravelInput,
            styles: everyTravelStyles,
            searchFormStyles: everyTravelSearchFormStyles,
            canCreateNewCart: order.status !== OrderStatus.Cancelled,
            canModifyOrderedCart: order.status === OrderStatus.New ||
                order.status === OrderStatus.Booked ||
                (order.status === OrderStatus.Confirmed && everyTravel.state === 'new')
        });
    }, [everyTravel, currency, locale, segment, order, updateCart, everyTravelStyles, everyTravelSearchFormStyles]);
    return (React.createElement(React.Suspense, { fallback: React.createElement("div", null, "Loading...") },
        React.createElement(EveryTravelWidget, { config: everyTravelParams, needToConfirmCart: needToConfirmCart })));
};
export default EveryTravelWrapper;
